// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2bj-p","head":"ProcedureTableInfo_head__1XOCy"};